
export interface IIntroductions {
    sit_id: string,
    tags: string[],
    content: string,
}
export class Introductions {
    constructor(public readonly data: { [key: string]: IIntroductions }) {
        //
    }

    filter(tags: string[]): IIntroductions[] {
        return Object.values(this.data).filter(it => tags.slice(1).every(t => it.tags.includes(t)));
    }

}
